import { bool, func } from 'prop-types'
import { PureComponent } from 'react'
import {
  kuiperClassNames,
  kuiperClassNamesWithTracking,
  CheckBox,
  Dropdown,
  Form,
  StatelessModal,
  ThumbSingleSelect,
  Menu,
  UnwrappedButton,
  Icon,
} from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'

import './styles.scss'

const EXPORT_FORMAT_OPTIONS = [
  {
    title: 'Digital',
    description: 'Best for email or display on screen',
    glyph: 'pdf-digital',
  },
  {
    title: 'Print',
    description: 'Best for output to a printer',
    glyph: 'pdf-print',
  },
]

const PAPER_SIZE_OPTIONS = [
  {
    id: 'letter',
    key: 'letter',
    title: 'LETTER',
  },
  {
    id: 'legal',
    key: 'legal',
    title: 'LEGAL',
  },
  {
    id: 'tabloid',
    key: 'tabloid',
    title: 'TABLOID',
  },
  {
    id: 'a4',
    key: 'a4',
    title: 'A4',
  },
  {
    id: 'a5',
    key: 'a5',
    title: 'A5',
  },
]

class PdfExportModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      exportIndex: 0,
      labelsEnabled: true,
      notesEnabled: true,
      optionsEnabled: true,
      paperSize: PAPER_SIZE_OPTIONS[0],
    }
  }

  setExportIndex = (value) => {
    this.setState({
      exportIndex: value,
    })
  }

  setPaperSize = (value) => {
    this.setState({
      paperSize: value,
    })
  }

  setDisplayOptions(optionKey) {
    this.setState((prevState) => ({ [optionKey]: !prevState[optionKey] }))
  }

  get exportSize() {
    if (this.state.exportIndex === 0) return 'digital'

    return this.state.paperSize.id
  }

  get paperOptions() {
    if (!this.shouldShowPaperOptions()) return null

    return (
      <div className={kuiperClassNames('paper-size')}>
        <h2>Choose a paper size</h2>
        <Dropdown
          onClick={() => {}}
          trigger={
            <UnwrappedButton
              label={this.state.paperSize.title}
              hasMenu={true}
              type="secondary"
              onClick={() => {}}
            />
          }
          content={
            <Menu
              options={PAPER_SIZE_OPTIONS}
              value={this.state.paperSize}
              onSelect={this.setPaperSize}
              role="listbox"
            />
          }
        />
      </div>
    )
  }

  get displayOptions() {
    return (
      <div className={kuiperClassNames('display-options')}>
        <h2>Display Options</h2>
        <CheckBox
          key="Options"
          label="Show content options"
          onChange={() => this.setDisplayOptions('optionsEnabled')}
          theme="dark"
          value={this.state.optionsEnabled}
        />
        <CheckBox
          key="Labels"
          label="Show labels"
          onChange={() => this.setDisplayOptions('labelsEnabled')}
          theme="dark"
          value={this.state.labelsEnabled}
        />
        <CheckBox
          key="Notes"
          label="Show notes"
          onChange={() => this.setDisplayOptions('notesEnabled')}
          theme="dark"
          value={this.state.notesEnabled}
        />
      </div>
    )
  }

  shouldShowPaperOptions = () => this.state.exportIndex === 1

  exportPdf = () => {
    this.props.createPdfExport({
      exportSize: this.exportSize,
      showLabels: this.state.labelsEnabled,
      showNotes: this.state.notesEnabled,
      showOptions: this.state.optionsEnabled,
    })

    this.props.onSubmit()
    this.props.onClose()
  }

  render() {
    const { onClose, visible } = this.props

    return (
      <AnalyticsLayer name="PDF Export">
        <StatelessModal
          onClose={onClose}
          visible={visible}
          customClassname={kuiperClassNamesWithTracking('pdf-export-modal', {
            tracking: 'pdf-export',
          })}
        >
          <Form
            cancelText="cancel"
            submitText="export"
            title="Export PDF"
            onSubmit={this.exportPdf}
            onCancel={onClose}
          >
            <div className={kuiperClassNames('top-section')}>
              <h2>Export Format</h2>
              <p>
                Select an export format based on how you plan to use your PDF.
              </p>
              <ThumbSingleSelect
                defaultSelection={this.state.exportIndex}
                items={EXPORT_FORMAT_OPTIONS}
                onChange={this.setExportIndex}
              >
                {({ item }) => (
                  <div className={kuiperClassNames('export-type')}>
                    <Icon
                      glyph={item.glyph}
                      height={168}
                      width={100}
                      ariaMode="hidden"
                    />
                  </div>
                )}
              </ThumbSingleSelect>
            </div>
            <div>
              <div className={kuiperClassNames('section-divider')} />
              <div className={kuiperClassNames('bottom-section')}>
                {this.displayOptions}
                {this.paperOptions}
              </div>
            </div>
          </Form>
        </StatelessModal>
      </AnalyticsLayer>
    )
  }
}

PdfExportModal.propTypes = {
  createPdfExport: func,
  onClose: func,
  onSubmit: func,
  visible: bool,
}

export default PdfExportModal
